export default () => {
  const $body = $('body');
  const $document = $(document);
  const $window = $(window);
  const $header = $('#js-header');
  const $sliderWrapper = $('#js-feature-hero.has-scroll-effect');
  const $slider = $('.c-feature-hero');
  const $sliderTitle = $('.c-feature-hero__title');

  function checkVisible(elm) {
    let rect = elm.get(0).getBoundingClientRect();
    let viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);

    if($body.hasClass('has-fixed-header')) {
      viewHeight = viewHeight + $header.outerHeight();
    }

    return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
  }

  $window.resize(() => {
    scrollAndResizeEvent();
  });
  $window.scroll(() => {
    scrollAndResizeEvent();
  });

  function scrollAndResizeEvent() {
    if($sliderWrapper.length > 0) {
      if($window.width() > mobileBreakpoint) {
        window.requestAnimationFrame(function() {
          parallax();
        });
      } else {
        clearParallaxValues();
      }
    }
  }

  function clearParallaxValues() {
    $slider.css({
      opacity: 1,
      transform: 'translateY(0px)'
    });
  }

  function parallax() {
    if(checkVisible($slider)) {
      let $mainSliderHeight = $sliderWrapper.outerHeight();
      let scrollPercent = ($mainSliderHeight - window.scrollY) / $mainSliderHeight;

      if(scrollPercent >= 0) {
        let actualHeight = 0;
    		let reSize = actualHeight - $window.scrollTop();
    		let makeParallax = -(reSize / 2).toFixed(2);

        if($window.scrollTop() === 0) {
          makeParallax = 0;
        }

    		let posValue = makeParallax + 'px';
        $slider.css({
          opacity: scrollPercent.toFixed(2),
          transform: 'translate3d(0, ' + posValue + ', 0)'
        });
        $sliderTitle.css({
          opacity: scrollPercent.toFixed(2) * 2,
          transform: 'translate3d(0, ' + posValue + ', 0)'
        });
      }
    }
  }
}
